import { Col, Row } from "react-bootstrap"
import { useAppSelector } from "../../../../../stateManagement/hooks/redux"
import SmallLoader from "../../../../loaders/SmallLoader"
import { formatDate } from "../../../../../features/dataFormatFunctions/dataFormatter"

const objects_icon = require('../../../../../assets/images/icons/objects_icon.png')
const road_icon = require('../../../../../assets/images/icons/road_icon.png')
const direction_icon = require('../../../../../assets/images/icons/direction_icon.png')
const found_results_icon = require('../../../../../assets/images/icons/found_results_icon.png')

function formatEventDate(EventStartDate: string, EventEndDate: string) {
    EventStartDate = EventStartDate ? formatDate(EventStartDate) : undefined;
    EventEndDate = EventEndDate ? formatDate(EventEndDate) : undefined;
    if (EventStartDate || EventEndDate) {
        return `${EventStartDate || 'не указано'} - ${EventEndDate || 'не указано'}`
    }
    return undefined
}

export function RoadMeasureResultsInfoContent() {

    const { roadName, pathName } = useAppSelector(state => state.pathsInfo.selectedPath) ?? {}
    const caption = useAppSelector(state => state.table.caption)
    const dataCount = useAppSelector(state => state.table.dataCount)
    const currentRoadDiagnosticsSegment = useAppSelector(state => state.roadDiagnosticsSegments.currentRoadDiagnosticsSegment)
    const currentRoadMeasure = useAppSelector(state => state.roadMeasures.currentRoadMeasure)
    const { ExecutorOrgName } = currentRoadDiagnosticsSegment ?? {}
    let { EventStartDate, EventEndDate, MeasureTypeString, AdmissibleValue } = currentRoadMeasure ?? {}
    AdmissibleValue = AdmissibleValue?.toString()?.replace('.', ',')
    let eventDate = formatEventDate(EventStartDate, EventEndDate)

    return (
        <>
            <h5 className="table-info-head">В таблице отображены:</h5>
            <Row>
                <Col  xs={12} md={6} xl={4} className="col">
                    <p>
                        <img src={objects_icon} className="basic-image" /><strong>Объекты:</strong>
                        <span className="table-info-value"> {caption}</span>
                    </p>
                    <p>
                        <img src={road_icon} className="basic-image" /><strong>По дороге:</strong>
                        <span className="table-info-value"> {roadName ? roadName : <SmallLoader iconColor="black" />}</span>
                    </p>
                    <p>
                        <img src={direction_icon} className="basic-image" /><strong>Направление:</strong>
                        <span className="table-info-value"> {pathName ? pathName : <SmallLoader iconColor="black" />}</span>
                    </p>
                    <p>
                        <img src={found_results_icon} className="basic-image" /><strong>Найдено объектов:</strong>
                        <span className="table-info-value"> {dataCount != null ? dataCount : <SmallLoader iconColor="black" />}</span>
                    </p>
                </Col>
                <Col xs={12} md={6} xl={4} className="col">
                    <p>
                        <strong>Дата:</strong>
                        <span className="table-info-value"> {eventDate != null ? eventDate : 'не указано'}</span>
                    </p>
                    <p>
                        <strong>Исполнитель:</strong>
                        <span className="table-info-value"> {ExecutorOrgName != null ? ExecutorOrgName : <SmallLoader iconColor="black" />}</span>
                    </p>
                    <p>
                        <strong>Тип измерения:</strong>
                        <span className="table-info-value"> {MeasureTypeString != null ? MeasureTypeString : <SmallLoader iconColor="black" />}</span>
                    </p>
                    <p>
                        <strong>Предельно допустимое значение:</strong>
                        <span className="table-info-value"> {AdmissibleValue != null ? AdmissibleValue : 'Не указано'}</span>
                    </p>
                </Col>
            </Row>
        </>
    )
}
